import { useState, useCallback, useEffect, useContext } from 'react';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import { AuthenticationContext } from './Contexts/Authentication';
import { useNavigate } from 'react-router-dom';
export const useServiceWorker = () => {
    const [waitingWorker, setWaitingWorker] = useState<ServiceWorker | null>(null);
    const [showReload, setShowReload] = useState<boolean>(false);
    const authentication = useContext(AuthenticationContext);

    const onSWUpdate = useCallback((registration: ServiceWorkerRegistration, version: string) => {
        setShowReload(true);
        setWaitingWorker(registration.waiting);
        authentication.setUpdateAvailable(version);
        window.location.href = '/update';
    }, [authentication]);
    
    const reloadPage = useCallback(() => {
        waitingWorker?.postMessage({ type: 'SKIP_WAITING' });
        setShowReload(false);
        window.location.reload();
    }, [waitingWorker]);

    useEffect(() => {
        serviceWorkerRegistration.register({
            onUpdate: onSWUpdate,
        });
    }, [onSWUpdate]);
    
    return { showReload, waitingWorker, reloadPage };
};